import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DensityMediumIcon(props: IconProps) {
    return <Icon {...props} iconKey={"density_medium"}/>
}
